import { EarningsInsightRating } from '@api';

export const getRatingColors = (rating: EarningsInsightRating) => {
  switch (rating) {
    case 'negative':
      return {
        backgroundColor: 'var(--viz-bearish-soft)',
        textColor: 'var(--viz-bearish)',
      };
    case 'positive':
      return {
        backgroundColor: 'var(--viz-bullish-soft)',
        textColor: 'var(--viz-bullish)',
      };
    default:
      return {
        backgroundColor: 'var(--surface-warning)',
        textColor: 'var(--text-warning)',
      };
  }
};
